import type { ReactNode } from 'react'
import { ButtonLink } from '../ui/Button'
import { Card, SectionTitle } from '../ui/Card'
import { cn } from '@/lib/utils'

interface DashboardWidgetCardProps {
  title: string
  viewAllHref?: string
  viewAllLabel?: string
  headerExtra?: ReactNode
  className?: string
  bodyClassName?: string
  children: ReactNode
}

/** Shared shell for dashboard widgets: a title bar with an optional "view all" link,
 * over a body area the widget controls. Each widget fetches its own data — this is
 * only chrome, so widgets stay self-contained (a prerequisite for a future
 * add/remove/rearrange dashboard). */
export function DashboardWidgetCard({
  title, viewAllHref, viewAllLabel = 'View All', headerExtra, className, bodyClassName, children,
}: DashboardWidgetCardProps) {
  return (
    <Card className={cn('overflow-hidden !p-0', className)}>
      <div className="px-5 pt-4 pb-3 border-b border-border flex items-center justify-between gap-2">
        <SectionTitle className="m-0 border-0 pb-0 mb-0">{title}</SectionTitle>
        <div className="flex items-center gap-2 flex-shrink-0">
          {headerExtra}
          {viewAllHref && <ButtonLink to={viewAllHref} variant="outline" size="sm">{viewAllLabel}</ButtonLink>}
        </div>
      </div>
      <div className={bodyClassName}>{children}</div>
    </Card>
  )
}
